<template>
    <v-card>
        <v-container fluid class="pa-0">
            <v-row>
                <v-col cols="12">
                    <v-data-table
                        :items="items"
                        :loading="isLoading"
                        :headers="headers"
                        :items-per-page="5"
                        :item-class="scheduledTaskClass"
                        :footer-props="{
                            itemsPerPageText: 'Zamówień na stronie',
                            showFirstLastPage: false,
                        }"
                        :mobile-breakpoint="0"
                        no-data-text="Brak Zamówień"
                    >
                        <template #item.taskNumber="{item}">
                            {{ item.procNumber }}
                        </template>
                        <template #item.plate="{item}">
                            {{ parseEmptyValue(item.procPlateNumber) }}
                        </template>
                        <template #item.closedFormat="{item}">
                            {{ parseEmptyValue(item.orderObject && item.orderObject.closedFormat) }}
                        </template>
                        <template #item.quantity="{item}">
                            {{ item.procTaskQuantity }}
                        </template>
                        <template #item.volume="{item}">
                            {{ parseEmptyValue(item.orderObject && item.orderObject.volume) }}
                        </template>
                        <template #item.foldedSignaturesQuantity="{item}">
                            {{ parseEmptyValue(item.orderObject && item.orderObject.foldedSignaturesQuantity) }}
                        </template>
                        <template #item.coverStatus="{item}">
                            {{ parseEmptyValue(item.orderObject && item.orderObject.coverStatus) }}
                        </template>
                        <template #item.innerStatus="{item}">
                            {{ parseEmptyValue(item.orderObject && item.orderObject.innerStatus) }}
                        </template>
                        <template #item.date="{item}">
                            {{ formatDate(item.procTaskStartTime) }}
                        </template>
                        <template #item.procTaskStartTime="{item}">
                            {{ formatDate(item.procTaskStartTime) }}
                        </template>
                        <template #item.procTaskDuration="{item}">
                            {{ parseDuration(item.procTaskDurationSeconds) }}
                        </template>
                        <template #item.status="{item}">
                            {{ item.procStatus | lowercase }}
                        </template>
                        <template #item.materialStatus="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-icon v-if="isWarehouseHasReportedStatus(item)" color="green" v-on="on">
                                            mdi-clipboard-check
                                        </v-icon>
                                        <v-icon v-else color="pink" v-on="on">
                                            mdi-clipboard-alert
                                        </v-icon>
                                    </template>
                                    <div>
                                        <div>MAGAZYN: {{ parseEmptyValue(item.wareHouseStatus) }}</div>
                                        <div>CTP: {{ parseBooleanValue(item.CTPStatus) }}</div>
                                        <div>GUMA: {{ parseBooleanValue(item.rubberStatus) }}</div>
                                    </div>
                                </v-tooltip>
                            </div>
                        </template>
                        <template #item.productionProcessFB="{item}">
                            {{ parseEmptyValue(item.productionProcessFB && item.productionProcessFB.name) }}
                        </template>
                        <template #item.actions="{item}">
                            <v-btn
                                color="primary"
                                text
                                data-sentry-label="Wybierz"
                                @click="openReport(item.id)"
                            >
                                Wybierz
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>

import dateFormatter from '@/mixins/dateFormatter'
import parse from '@/mixins/parse'
import tooltipDelay from '@/mixins/tooltip'

export default {
    name: 'ReportingProcessingReportsTable',
    mixins: [
        dateFormatter,
        parse,
        tooltipDelay,
    ],
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        isLoading: {
            type: Boolean,
        },
        headers: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        scheduledTaskClass(item) {
            return item.procStatus === 'Zakończone' ? 'success--text' : ''
        },
        isWarehouseHasReportedStatus(item) {
            return item.wareHouseStatus && item.wareHouseStatus.toLowerCase() === 'zakończone'
        },
        openReport(id) {
            this.$emit('open-report', id)
        },
    },
}
</script>
